import { AxiosInstance } from 'axios';
import DevScrumRepositoryInterface, { AuditInterface, AuditTableInterface, ComponentInterface } from './interfaces';


export default class DevScrumRepository implements DevScrumRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllAudits(): Promise<AuditTableInterface[]> {
    const res = await this.axios.get(`/dev-scrum/audits`);

    return res.data;
  }

  public async getAuditById(id: number): Promise<AuditInterface> {
    const res = await this.axios.get(`/dev-scrum/audits/${id}`);
    console.log(res.data);

    return res.data;
  }

  public async editAudit(id: number, data: any): Promise<void> {
    const res = await this.axios.patch(`/dev-scrum/audits/${id}`, data);
  }

  public async getAuditsByUser(userId: string): Promise<AuditTableInterface[]> {
    const res = await this.axios.get(`/dev-scrum/audits/users/${userId}`);

    return res.data;
  }

  public async getComponentById(componentId: number): Promise<ComponentInterface> {
    const res = await this.axios.get(`/dev-scrum/components/${componentId}`);

    return res.data;
  }

  public async editComponent(componentId: number, data: any): Promise<void> {
    const res = await this.axios.patch(`/dev-scrum/components/${componentId}`, data);

    return res.data;
  }

  public async getAllComponents(): Promise<ComponentInterface[]> {
    const res = await this.axios.get(`/dev-scrum/components`);

    return res.data;
  }

  public async getAllActiveComponents(): Promise<ComponentInterface[]> {
    const res = await this.axios.get(`/dev-scrum/components/status/active`);

    return res.data;
  }


  public async createAudit(form: AuditInterface): Promise<AuditInterface> {
    const res = await this.axios.post(`dev-scrum/audits`, form);

    return res.data;
  }

  public async createAudits(forms: AuditInterface[]): Promise<AuditInterface[]> {
    const res = await this.axios.post(`dev-scrum/audits`, forms);

    return res.data;
  }

  public async createComponent(name: string, status: string): Promise<ComponentInterface> {
    const res = await this.axios.post(`dev-scrum/components`, { name, status });

    return res.data;
  }

  public async createComponents(names: any): Promise<ComponentInterface[]> {
    const res = await this.axios.post(`dev-scrum/components`, names);

    return res.data;
  }

  public async deleteComponent(id: number): Promise<void> {
    await this.axios.delete(`dev-scrum/components/${id}`);
  }

  public async deleteAuditById(id: number): Promise<void> {
    await this.axios.delete(`dev-scrum/audits/${id}`);
  }
}

